import ApisMethods from './apisMethods'
import {factoryNameToPaySlug, toIsoCurrencyCode} from '../utils/paymentHelpers'

const PackagesApi = {  getPackageCategories: (callback: any, setIsLoading: any) => {
    //
    let url = `/vendor/packages/categories`

    ApisMethods().get(url, callback, setIsLoading)
  },
  getInfo: (callback: any, setIsLoading: any) => {
    //
    let url = `/vendor/subscriptions`

    ApisMethods().get(url, callback, setIsLoading)
  },
  getHistory: (
    searchText: string,
    rowsPerPage: number,
    page: number,
    callback: any,
    setIsLoading: any
  ) => {
    //
    let url = `/vendor/subscriptions/history??page=${page}&per_page=${rowsPerPage}`

    ApisMethods().get(url, callback, setIsLoading)
  },
  getHistoryById: (
    id: any,

    callback: any,
    setIsLoading: any
  ) => {
    //
    let url = `/vendor/subscriptions/details/${id}`

    ApisMethods().get(url, callback, setIsLoading)
  },
  getInvoById: (
    id: any,

    callback: any,
    setIsLoading: any
  ) => {
    //
    let url = `/vendor/subscriptions/invoice/${id}`

    ApisMethods().get(url, callback, setIsLoading)
  },
  getPackageCategoriesById: (id: any, callback: any, setIsLoading: any) => {
    //
    let url = `/vendor/packages/${id}`

    ApisMethods().get(url, callback, setIsLoading)
  },
  upgrade: (data: any, callback: any, setIsLoading: any, isCallbackErr?: any) => {
    ApisMethods(isCallbackErr).post(`/vendor/subscription/upgrade`, data, callback, setIsLoading)
  },
  upgradeConfirm: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/subscription/upgrade/confirm`, data, callback, setIsLoading)
  },
  renew: (callback: any, setIsLoading: any) => {
    // Prefer POST; GET kept on backend for compatibility
    ApisMethods().post(`/vendor/subscription/renew`, {}, callback, setIsLoading)
  },
  renewConfirm: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/subscription/renew/confirm`, data, callback, setIsLoading)
  },
  resendOtp: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/common/resend-code`, data, callback, setIsLoading)
  },
  payWhish: (data: any, callback: any, setIsLoading: any) => {
    const payload = {
      ...(data || {}),
      currency_code: toIsoCurrencyCode(data?.currency_code),
    }
    ApisMethods().post(`/vendor/subscriptions/pay-whish`, payload, callback, setIsLoading)
  },
  /** POST /vendor/subscriptions/pay-{whish|blom|...} */
  payByGateway: (factoryName: string, data: any, callback: any, setIsLoading: any) => {
    const slug = factoryNameToPaySlug(factoryName)
    const payload = {
      ...(data || {}),
      currency_code: toIsoCurrencyCode(data?.currency_code),
    }
    ApisMethods().post(`/vendor/subscriptions/pay-${slug}`, payload, callback, setIsLoading)
  },
}
export default PackagesApi
